// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"c1f142c7","436":"ac7869b8","453":"f394a27d","501":"7d17cf62","606":"aba5df80","925":"a738453e"}[chunkId] + ".chunk.js";
};